const util = {
  formatDate(dateString) {
    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      const year = date.toLocaleDateString('en-US', {
        timeZone: 'Australia/Adelaide',
        year: 'numeric',
      });

      const month = date.toLocaleDateString('en-US', {
        timeZone: 'Australia/Adelaide',
        month: 'long',
      });

      const day = date.toLocaleDateString('en-US', {
        timeZone: 'Australia/Adelaide',
        day: 'numeric',
      });

      return `${day} ${month} ${year}`;
    } catch (error) {
      console.error('Date formatting error:', error);
      return 'Invalid Date Format';
    }
  },

  formatDateTime(dateTimeString) {
    try {
      const date = new Date(dateTimeString);

      if (isNaN(date.getTime())) {
        return 'Invalid Date Time';
      }

      const formattedDate = this.formatDate(dateTimeString);
      const formattedTime = this.formatTime(date);

      return `${formattedDate} at ${formattedTime}`;
    } catch (error) {
      console.error('Date-time formatting error:', error);
      return 'Invalid Date Time Format';
    }
  },

  formatTime(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minutes} ${ampm}`;
  }
};

export default util;



// WEBPACK FOOTER //
// ./src/untils/util.js